
//---------------------10/01/2025-----------------working--------
import React, { useState, useEffect } from 'react';
import FlightCard from './FlightCard';
import FlightRoutes from './FlightRoutes';
// import { useNavigate } from "react-router-dom";
import Calendar from 'react-calendar';
import '../Styles/FlightSearches.css'
import 'react-calendar/dist/Calendar.css';
import { FaRegCalendarDays } from "react-icons/fa6";
import {jwtDecode} from "jwt-decode";

const FlightSearch = () => {
  const [tripType, setTripType] = useState('oneway');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [date, setDate] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [paxSize, setPaxSize] = useState(1);

  const [isToEnabled, setIsToEnabled] = useState(false);
  const [isDateEnabled, setIsDateEnabled] = useState(false);
  const [isPaxEnabled, setIsPaxEnabled] = useState(false);

  const [departureOptions, setDepartureOptions] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [returnCalendarVisible, setReturnCalendarVisible] = useState(false);
 const [sortType, setSortType] = useState("low");
  // Example: Highlighted dates from the fetched API
  const [highlightedDates, setHighlightedDates] = useState([]);

  const [searchResults, setSearchResults] = useState([]);
//  const navigate = useNavigate();
 let priceData;
  const storedToken = localStorage.getItem('b2bAuthToken');
  const parsedToken = storedToken ? JSON.parse(storedToken) : null;
  const externalApiToken = parsedToken ? parsedToken.externalApiToken : null;

    const sortedSearchResults = [...searchResults].sort((a, b) =>
    sortType === "low"
      ? Number(a.price) - Number(b.price)
      : Number(b.price) - Number(a.price)
  );

  useEffect(() => {
  if (!externalApiToken) {
    console.error("Authorization token is missing.");
    return;
  }

  fetch("https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/sec678rot", {
    headers: {
      Authorization: externalApiToken,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Unauthorized or failed to fetch sectors.");
      }
      return response.json();
    })
    .then((data) => {
      if (data.status === "success" && data.data) {
        const uniqueOrigins = Array.from(
          new Set(data.data.map((item) => item.origin))
        ).map((origin) => {
          const matchedItem = data.data.find((item) => item.origin === origin);
          return {
            code: origin,
            name: matchedItem ? matchedItem.sectorName.split(" // ")[0] : origin,
          };
        });
        setDepartureOptions(uniqueOrigins);
      }
    })
    .catch((error) => console.error("Error fetching sectors:", error));
}, [externalApiToken]);


  const fetchAvailableDates = async (origin, destination) => {
    if (!origin || !destination) {
      console.error("Both 'from' (origin) and 'to' (destination) are required.");
      return;
    }

    const payload = { origin, destination };

    try {
      console.log("Payload sent to API for dates:", payload);

      const response = await fetch("https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/al19il75y", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${externalApiToken}`, // Include Bearer token
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "success" && Array.isArray(data.data)) {
        console.log("Available dates from API:", data.data);
        setAvailableDates(data.data);
      } else {
        console.error("Invalid response structure for dates:", data);
        setAvailableDates([]); // Reset if the structure is invalid
      }
    } catch (error) {
      console.error("Error fetching available dates:", error.message);
      setAvailableDates([]); // Reset on error
    }
  };

const handleFromChange = (e) => {
  const selectedFrom = e.target.value;
  setFrom(selectedFrom);
  setIsToEnabled(true);

  fetch("https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/sec678rot", {
    headers: {
      Authorization: `${externalApiToken}`,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "success" && data.data) {
        const filteredDestinations = data.data
          .filter((item) => item.origin === selectedFrom)
          .map((item) => ({ 
            code: item.destination, 
            name: item.sectorName.split(" // ")[1],
          }));
        setDestinationOptions(filteredDestinations);
      }
    })
    .catch((error) => console.error("Error fetching destinations:", error));
};

  const handleToChange = (e) => {
    const selectedTo = e.target.value;
    setTo(selectedTo);

    if (from && selectedTo) {
      setIsDateEnabled(true); // Enable date selection
      fetchAvailableDates(from, selectedTo); // Fetch dates
    }
  };

   const handleSearch = async () => {
    if (!tripType || !from || !to || !date || paxSize < 1) {
      console.error("All fields are required for the search.");
      return;
    }
  
    // const storedToken = localStorage.getItem("b2bAuthToken");
    // const externalApiToken = storedToken ? JSON.parse(storedToken).externalApiToken : null;


const storedToken = localStorage.getItem("b2bAuthToken");
const parsedToken = storedToken ? JSON.parse(storedToken) : null;
const token = parsedToken?.token;

let agencyId = null;

if (token) {
  const decoded = jwtDecode(token); // Decodes payload of the JWT
  agencyId = decoded?.id || null;   // Use `decoded?._id` if _id is directly in payload
  console.log("Decoded Agency ID:", agencyId);
}


    if (!externalApiToken) {
      console.error("Authorization token is missing.");
      alert("Authentication failed. Please log in again.");
      return;
    }
  
    const payload = {
      tripType,
      origin: from,
      destination: to,
      departure_date: date,
      adult: paxSize,
      child: paxSize,
      infant: paxSize,
    };
  
    try {
      const response = await fetch("https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/se12rch35", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: externalApiToken,
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      
      if (data.status === "success" && Array.isArray(data.data)) {
        // Now for each flight, fetch the updated price
        const flightsWithUpdatedPrice = await Promise.all(
          data.data.map(async (flight) => {
            try {
              const priceResponse = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/ad78fe00s/${agencyId}`,
                //"https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/ad78fe00s", 
                {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ basePrice: flight.price }), // Assuming your flight has `price` field
              });
  
              if (!priceResponse.ok) {
                throw new Error(`Failed to update price for flight ID: ${flight.ticket_id}`);
              }
  
               priceData = await priceResponse.json();
               console.log("pricedata",priceData.extraAmount);
              if (priceData.status === "success") {
                return {
                  ...flight,
                  price: priceData.updatedPrice,
                  data1:priceData.extraAmount,
                   // Replace with updated price
                };
              } else {
                return flight; // In case of error, return original flight
              }
            } catch (error) {
              console.error("Error updating flight price:", error);
              return flight;
            }
          })
        );
  
        setSearchResults(flightsWithUpdatedPrice);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
      setSearchResults([]);
    }
  };
  
    
      useEffect(() => {
        const convertedDates = availableDates.map((dateString) => {
          // Convert DD-MMM-YYYY format to Date object
          const [day, monthStr, year] = dateString.split('-');
          const month = new Date(`${monthStr} 1, 2000`).getMonth(); // Get month index from string
          return new Date(year, month, parseInt(day));
        });
        console.log("Converted Dates:", convertedDates);
        setHighlightedDates(convertedDates);
      }, [availableDates]);
    
      const toggleCalendar = () => {
        setCalendarVisible((prev) => !prev);
      };
      const tileClassName = ({ date, view }) => {
        if (view === 'month') {
          const isHighlighted = highlightedDates.some(
            (highlightedDate) =>
              date.getFullYear() === highlightedDate.getFullYear() &&
              date.getMonth() === highlightedDate.getMonth() &&
              date.getDate() === highlightedDate.getDate()
          );
          return isHighlighted ? 'highlighted-date' : null; // Return class name
        }
        return null;
      };

      const toggleReturnCalendar = () => {
        setReturnCalendarVisible((prev) => !prev);
      };
      const tileClassName1 = ({ date, view }) => {
        if (view === 'month') {
          const isHighlighted = highlightedDates.some(
            (highlightedDate) =>
              date.getFullYear() === highlightedDate.getFullYear() &&
              date.getMonth() === highlightedDate.getMonth() &&
              date.getDate() === highlightedDate.getDate()
          );
          return isHighlighted ? 'highlighted-date' : null; // Return class name
        }
        return null;
      };
    
      const handleRouteSelection = (origin, destination) => {
        setFrom(origin);
        setTo(destination);
        setIsToEnabled(true);
    
        fetch("https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.u1e2r3/sec678rot", {
          headers: {
            Authorization: externalApiToken,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === "success" && data.data) {
              const filteredDestinations = data.data
                .filter((item) => item.Origin === origin)
                .map((item) => ({
                  code: item.Destination,
                  name: item.Sector.split(" // ")[1],
                }));
              setDestinationOptions(filteredDestinations);
            }
          })
          .catch((error) => console.error("Error fetching destinations:", error));
    
        if (origin && destination) {
          setIsDateEnabled(true);
          fetchAvailableDates(origin, destination);
        }
      };

  return (
    

<div>
  <div className="container">
    <div className="tripType">
      <button
        className={tripType === 'oneway' ? 'activeButton' : 'button'}
        onClick={() => setTripType('oneway')}
      >
        ONEWAY
      </button>
      {/* <button
        className={tripType === 'roundtrip' ? 'activeButton' : 'button'}
        onClick={() => setTripType('roundtrip')}
      >
        ROUND TRIP
      </button> */}
    </div>

    <div className="searchPanel">
      <div className="fieldsRow">
        <div className="field">
          <label className="label">FROM</label>
          <select value={from} onChange={handleFromChange} className="select">
            <option value="">Select Departure</option>
            {departureOptions.map((option) => (
              <option key={option.code} value={option.code}>
                 {`${option.code} - ${option.name}`} {/* Combine code and name */}
                {/* {option.name} */}
              </option>
            ))}
          </select>
        </div>

  
        <div className="field">
          <label className="label">TO</label>
          <select
            value={to}
            onChange={handleToChange}
            disabled={!isToEnabled}
            className="select"
          >
            <option value="">Select Destination</option>
            {destinationOptions.map((option) => (
              <option key={option.code} value={option.code}>
               {`${option.code} - ${option.name}`}
              </option>
            ))}
          </select>
        </div>
                 
                  
          <div className="field">
                    <label className="label">TRAVEL DATE</label>
                    <div className="date-picker-container">
            <input
              type="text"
              placeholder="From Date"
              value={date}
              readOnly
              className="date-input"
              onClick={toggleCalendar} // Open the calendar on input click
            />
            <div className='icon-container'>
            <span className="calendar-icon" onClick={toggleCalendar}>
            <FaRegCalendarDays />
            </span>
            </div>
            {calendarVisible && (
              <div className="calendar-container">
                <Calendar
                formatShortWeekday={(locale, date) =>
                  date.toLocaleDateString(locale, { weekday: 'short' }).slice(0, 2)
                }
                
            tileClassName={tileClassName} // Highlight the appropriate dates
            tileDisabled={({ date }) => {
              const isHighlighted = highlightedDates.some(
                (highlightedDate) =>
                  date.getFullYear() === highlightedDate.getFullYear() &&
                  date.getMonth() === highlightedDate.getMonth() &&
                  date.getDate() === highlightedDate.getDate()
              );
              return !isHighlighted; // Disable non-highlighted dates
            }}
              onClickDay={(value) => {
                // Check if the selected date is highlighted
                const isHighlighted = highlightedDates.some(
                  (highlightedDate) =>
                    value.getFullYear() === highlightedDate.getFullYear() &&
                    value.getMonth() === highlightedDate.getMonth() &&
                    value.getDate() === highlightedDate.getDate()
                );

                if (isHighlighted) {
                  // Format the date to DD-MMM-YYYY
                  const day = value.getDate().toString().padStart(2, '0'); // Ensure 2-digit day
                  const month = value.toLocaleString('en-US', { month: 'short' }); // Uppercase month
                  const year = value.getFullYear();
                  const formattedDate = `${day}-${month}-${year}`; // Combine into desired format
                  setDate(formattedDate); 
                  setIsPaxEnabled(true);// Update the state with the formatted date
                  setCalendarVisible(false); // Close the calendar
                } else {
                alert('Please select a highlighted date.');
              }
            }}
          />
              </div>
            )}
          </div>
                  </div>
                  {tripType === 'roundtrip' && (
                    <div className="field">
                    <label className="label">RETURN DATE</label>
                    <div className="date-picker-container">
            <input
              type="text"
              placeholder="Return Date"
              value={returnDate}
              readOnly
              className="date-input"
              onClick={toggleReturnCalendar} // Open the calendar on input click
            />
            <div className='icon-container'>
            <span className="calendar-icon" onClick={toggleReturnCalendar}>
            <FaRegCalendarDays />
            </span>
            </div>
            {returnCalendarVisible && (
              <div className="calendar-container">
                <Calendar
                formatShortWeekday={(locale, date) =>
                  date.toLocaleDateString(locale, { weekday: 'short' }).slice(0, 2)
                }
              
            tileClassName1={tileClassName1} // Highlight the appropriate dates
            tileDisabled={({ date }) => {
              const isHighlighted = highlightedDates.some(
                (highlightedDate) =>
                  date.getFullYear() === highlightedDate.getFullYear() &&
                  date.getMonth() === highlightedDate.getMonth() &&
                  date.getDate() === highlightedDate.getDate()
              );
              return !isHighlighted; // Disable non-highlighted dates
            }}
              onClickDay={(value) => {
                // Check if the selected date is highlighted
                const isHighlighted = highlightedDates.some(
                  (highlightedDate) =>
                    value.getFullYear() === highlightedDate.getFullYear() &&
                    value.getMonth() === highlightedDate.getMonth() &&
                    value.getDate() === highlightedDate.getDate()
                );

                if (isHighlighted) {
                  // Format the date to DD-MMM-YYYY
                  const day = value.getDate().toString().padStart(2, '0'); // Ensure 2-digit day
                  const month = value.toLocaleString('en-US', { month: 'short' }); // Uppercase month
                  const year = value.getFullYear();
                  const formattedDate = `${day}-${month}-${year}`; // Combine into desired format
                  setReturnDate(formattedDate);
                  setIsPaxEnabled(true);// Update the state with the formatted date
                  setReturnCalendarVisible(false);// Close the calendar
                } else {
                alert('Please select a highlighted date.');
              }
            }}
          />
              </div>
            )}
          </div>
                  </div>       
                  )}

        <div className="field">
          <label className="label">PAX SIZE</label>
          <input
            type="number"
            value={paxSize}
            min="1"
            onChange={(e) => setPaxSize(Number(e.target.value))}
            disabled={!isPaxEnabled}
            className="input"
          />
        </div>

        <button
          className="searchButton"
          onClick={handleSearch}
          disabled={!isPaxEnabled}
        >
          SEARCH
        </button>
        {/*<input type="text" value="Note: Select date after 30 days from current date" className="flightSearch-note"/>*/}
      </div>
    
    </div>
    {/* <div className="main">
  {searchResults.length > 0 && searchResults.map((flight) => (
    <FlightCard
      key={flight.ticket_id}
      flight={flight}
      seatData={{
        adults: paxSize,
        children: 0,
        infants: 0,
      }}
      updatedPrice={flight.data1}
    />
  ))}
</div> */}
<div className="container">
      {/* ✅ ONLY NEW UI (SORT DROPDOWN) */}
      {searchResults.length > 0 && (
        <div style={{ textAlign: "right", marginBottom: "15px" }}>
          <select
            className="select"
            value={sortType}
            onChange={(e) => setSortType(e.target.value)}
          >
            <option value="low">Price: Low to High</option>
            <option value="high">Price: High to Low</option>
          </select>
        </div>
      )}
 <div className="main">
        {sortedSearchResults.map((flight) => (
          <FlightCard
            key={flight.ticket_id}
            flight={flight}
            seatData={{ adults: paxSize, children: 0, infants: 0 }}
            updatedPrice={flight.data1}
          />
        ))}
      </div>
      </div>
    {/* <div className="main">
      {searchResults.length > 0 ? (
        searchResults.map((flight) => (
          <FlightCard
            key={flight.ticket_id}
            flight={flight}
            seatData={{
              adults: paxSize,
              children: 0,
              infants: 0,
            }}
              updatedPrice={flight.data1} // ✅ Add this line
          />
          
        ))

      ) : (
        <FlightRoutes onSelectRoute={handleRouteSelection} />
      )}
    </div> */}
  </div>
</div>
  );
};

export default FlightSearch;
  